"use client";
import React, { useEffect, useState } from "react";
import { CustomNavigationClient, msalInstance } from "@/lib/auth";
import { AuthenticationResult, EventType } from "@azure/msal-browser";
import { useRouter } from "next/navigation";
import { MsalProvider } from "@azure/msal-react";
import { Providers } from "@/components/providers";
import { initBugsnag } from "@/lib/bugsnag";

export const AppRoot = ({ children }: { children: React.ReactNode }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const router = useRouter();

    useEffect(() => {
        initBugsnag();
    }, []);

    useEffect(() => {
        const initializeMsal = async () => {
            await msalInstance.initialize();

            try {
                const result = await msalInstance.handleRedirectPromise();
                if (result && result.account) {
                    msalInstance.setActiveAccount(result.account);
                }
            } catch (error) {
                console.error("[MSAL] Redirect error:", error);
            }

            // Set up account selection for existing sessions
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                msalInstance.setActiveAccount(accounts[0]);
            }

            // Set up event callback
            msalInstance.addEventCallback((event) => {
                const result = event.payload as AuthenticationResult | null;
                if (result && event.eventType === EventType.LOGIN_SUCCESS && result.account) {
                    msalInstance.setActiveAccount(result.account);
                }
            });

            // Set navigation client
            const navigationClient = new CustomNavigationClient(router);
            msalInstance.setNavigationClient(navigationClient);

            setIsInitialized(true);
        };

        initializeMsal();
    }, [router]);

    if (!isInitialized) {
        return null;
    }

    return (
        <MsalProvider instance={msalInstance}>
            <Providers>{children}</Providers>
        </MsalProvider>
    );
};
